// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__g3K3W","info":"Note_info__1sWqs","note":"Note_note__2TZJU","actions":"Note_actions__GIhSQ"};